import { render, staticRenderFns } from "./signinsuccess.vue?vue&type=template&id=67893995&scoped=true"
import script from "./signinsuccess.vue?vue&type=script&lang=js"
export * from "./signinsuccess.vue?vue&type=script&lang=js"
import style0 from "./signinsuccess.vue?vue&type=style&index=0&id=67893995&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67893995",
  null
  
)

export default component.exports